module.exports = __webpack_public_path__ + "media/img/avatars/products/product-2-23012740e7bb45fd94f28608a893a08f.jpg";